export enum QuestionGroupTypeEnum  {
  TEMPLATE=1,
  USER_DEFINED=2,
}
